import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import PasswordField from "../components/PasswordField";
import { LogoMark } from "../components/Logo";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato!");
      nav(u.sector ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore login");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col">
      <div className="relative flex-1 flex items-center justify-center px-6 py-10">
        <div className="absolute inset-0 opacity-30 pointer-events-none"
             style={{ backgroundImage: "url('https://images.pexels.com/photos/19071946/pexels-photo-19071946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/40" />
        <div className="relative w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <LogoMark size={56} />
            <div className="font-heading text-3xl font-black uppercase leading-none">ETA<span className="text-[#FFD600]">Build</span></div>
          </div>

          <h1 className="font-heading text-5xl font-black uppercase tracking-tighter leading-none mb-8">Accedi</h1>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs text-[#A3A3A3] uppercase tracking-wider font-bold mb-2 block">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                className="w-full bg-[#1A1A1A] border-2 border-[#333] h-14 text-lg text-white rounded-md px-4 focus:border-[#FFD600] focus:outline-none" />
            </div>
            <PasswordField label="Password" dataTestId="login-password" value={password} onChange={(e)=>setPassword(e.target.value)} />
            <button data-testid="login-submit" disabled={loading} type="submit"
              className="w-full bg-[#FFD600] text-[#0A0A0A] h-16 text-xl font-black uppercase tracking-tight rounded-md hover:bg-[#E6C200] transition disabled:opacity-50">
              {loading ? "Caricamento..." : "Entra"}
            </button>
          </form>
          <div className="mt-6 text-center text-[#A3A3A3]">
            <Link to="/forgot-password" className="text-[#FFD600] font-bold uppercase text-sm" data-testid="forgot-link">Password dimenticata?</Link>
          </div>
          <div className="mt-3 text-center text-[#A3A3A3]">
            Non hai un account? <Link to="/register" className="text-[#FFD600] font-bold uppercase" data-testid="goto-register">Registrati</Link>
          </div>
          <div className="mt-6 pt-4 border-t border-[#1A1A1A] text-center text-xs text-[#666] flex gap-3 justify-center">
            <Link to="/privacy" className="hover:text-[#FFD600] underline" data-testid="privacy-link-login">Privacy</Link>
            <span>·</span>
            <Link to="/termini" className="hover:text-[#FFD600] underline" data-testid="terms-link-login">Termini & Condizioni</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
